<template>
    <section class="inner_banner">
        <div class="container">
            <h2 class="title">Faqs</h2>
            <div class="faq">
                <div class="panel-group" id="accordion" role="tablist" aria-multiselectable="true">
                    <div class="panel panel-default">
                        <div class="panel-heading" role="tab" id="headingOne">
                            <h4 class="panel-title">
                                <a role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                    How do I buy characters to use in the game?
                                </a>
                            </h4>
                        </div>
                        <div id="collapseOne" class="panel-collapse collapse show" role="tabpanel" aria-labelledby="headingOne" data-parent="#accordion">
                            <div class="panel-body">
                                <p>Buying characters is easy! All that you will need to do is go to the ETH Fighter Store, and purchase the character that you want to use. If you want to play the game, then you need to have purchased at least one character. </p>
                            </div>
                        </div>
                    </div>
                    <div class="panel panel-default">
                        <div class="panel-heading" role="tab" id="headingTwo">
                            <h4 class="panel-title">
                                <a class="collapsed" role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                    Do you have a referral programme?
                                </a>
                            </h4>
                        </div>
                        <div id="collapseTwo" class="panel-collapse collapse" role="tabpanel" aria-labelledby="headingTwo" data-parent="#accordion">
                            <div class="panel-body">
                                <p>You can earn ETH by referring a friend to the game, you need to provide your Ethereum address in the
                                    <a href="#">referral programme box </a> to generate your referral link. Once you have referred someone, you will generate income every time they make a purchase in the Eth Fighter store.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="panel panel-default">
                        <div class="panel-heading" role="tab" id="headingThree">
                            <h4 class="panel-title">
                                <a class="collapsed" role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                    I’m having problems purchasing a character from the store. What do I do?
                                </a>
                            </h4>
                        </div>
                        <div id="collapseThree" class="panel-collapse collapse" role="tabpanel" aria-labelledby="headingThree" data-parent="#accordion">
                            <div class="panel-body">
                                <p>First of all, you need to make sure that you have sufficient funds. Secondly, check that you have put in all of your details properly. Finally check that the character is still in stock, remember there is a limited number of each character! All characters work on a limited supply, so it may be the case that you can’t access a particular character until it restarts. If you’re having a specific technical issue, please
                                    <a href="contact.php">contact</a> a member of the team. </p>
                            </div>
                        </div>
                    </div>
                    <div class="panel panel-default">
                        <div class="panel-heading" role="tab" id="headingFour">
                            <h4 class="panel-title">
                                <a class="collapsed" role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                                    How do I unlock a specific character?
                                </a>
                            </h4>
                        </div>
                        <div id="collapseFour" class="panel-collapse collapse" role="tabpanel" aria-labelledby="headingFour" data-parent="#accordion">
                            <div class="panel-body">
                                <p>Unlocking characters will determine the level of choice you have in the game. However, there may be an instance where you can’t get a specific character. Depending on the time you’re trying to unlock it, it may not be in stock, or even been released yet. It’s worth checking back in every couple of weeks to make sure that your chosen character is available - and being quick when it does appear! </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: "Faq"
}
</script>

<style scoped>

</style>
